import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';

import {
  formatPrice,
} from 'helpers/utils';
import immutableToJS from 'helpers/immutableToJS';
import {
  InvoiceBadge,
} from 'components';
import { selectState } from 'redux/selectors';
import { refreshToken } from 'redux/auth/actions';

class OrderPendingStatusBadge extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    info: PropTypes.shape({}).isRequired,
  };

  static defaultProps = {
    // orderRequesting: false,
  };

  render() {
    const {
      info,
      formatMessage,
    } = this.props;

    const paid = Number(info.pending) >= Number(info.totalPrice);

    return (
      <Fragment>
        {
          <InvoiceBadge
            type={paid ? 'paid' : 'pending'}
          >
            <div className="d-flex align-items-center">
              <strong style={{ textAlign: 'left' }}>
                <span style={{ fontSize: 14, lineHeight: '24px' }}>
                  {paid ? formatMessage('Paid') : `$${formatPrice(info.pending)}/$${formatPrice(info.totalPrice)}`}
                </span>
              </strong>
            </div>
          </InvoiceBadge>
        }
      </Fragment>
    );
  }
}
/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('orders', 'order')(state),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  refreshToken: () => dispatch(refreshToken()),
});

export default compose(
  setDisplayName('OrderPendingStatusBadge'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  immutableToJS,
)(OrderPendingStatusBadge);
